<template>
  <div class="wrapper">
    <br />
    <div>
      <el-row>
        <el-col :span="10">
          <el-select
            v-model="cliente"
            placeholder="Clientes"
            filterable
            :loading="isLoadin"
            @change="handlerChange"
            class="supliers_select"
          >
            <el-option
              v-for="item in clientes"
              :key="item.value"
              :label="item.label"
              :value="item.Value"
            />
          </el-select>
        </el-col>
        <el-col :span="2">
          Habilitar Modificacion
          <el-switch
            v-model="value"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="switchChange"
          >
          </el-switch>
        </el-col>
      </el-row>
    </div>
    <br />
    <div>
      <el-tabs type="border-card" @tab-click="handleClick">
        <el-tab-pane label="Navixy">
          <el-row>
            <el-col :span="10">
              <Navyxioncomponent
                :Cliente="cliente"
                :Productos="Productos"
                :DataSave="Click"
                @Guardar-Datos="GuardarDatosNavision"
                :Enables="value"
                :TabChange="index"
              />
            </el-col>
            <div class="v-line"></div>
            <el-col :span="10" id="GPS">
              <GpsComponent :Cliente="clientegps" @GPSDATA="SelectData2" />
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="Terminales">
          <el-row>
            <el-col :span="10">
              <Navyxioncomponent
                :Cliente="cliente"
                :Productos="Productos"
                :DataSave="Click"
                @Guardar-Datos="GuardarDatosNavision"
                :Enables="value"
                :TabChange="index"
              />
            </el-col>
            <div class="v-line"></div>
            <el-col :span="10" id="GPS">
              <TerminalesComponents
                :Data="data"
                :Cliente="clienteTerminal"
                @TERMINALESDATA="SelectData"
              />
            </el-col>
          </el-row>
        </el-tab-pane>
        <br />
        <div>
          <el-button type="primary" round @click="HandlerOnclick">
            Guardar Datos
          </el-button>
        </div>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import Navyxioncomponent from "@/views/modules/projects/components/Navyxion.vue";
import GpsComponent from "@/views/modules/projects/components/GPSComponent.vue";
import TerminalesComponents from "@/views/modules/projects/components/TerminalesComponents.vue";

export default {
  name: "contract",
  components: {
    Navyxioncomponent,
    GpsComponent,
    TerminalesComponents
  },
  data() {
    return {
      activeName: "first",
      clientes: [],
      isLoadin: false,
      cliente: "",
      clientegps: "",
      clienteTerminal: "",
      index: "0",
      Productos: [],
      data: [],
      SaveData: [],
      Empresas: [],
      Click: Boolean,
      value: true
    };
  },
  async mounted() {
    await this.GetCustomer();
    await this.$store.dispatch("navixy/getTotalUsers");
    await this.$store.dispatch("navixy/getTotalGps");
  },

  methods: {
    async handleClick(tab) {
      this.Productos = [];
      this.clientes = [];
      this.index = tab.index;
      this.cliente = "";
      await this.FilterChange(this.index);
    },

    switchChange(val) {
      this.value = val;
    },

    handlerChange() {
      if (this.index == 0) {
        this.clientegps = this.cliente;
      } else {
        this.clienteTerminal = this.cliente;
      }
    },

    SelectData(value) {
      this.Productos = [];
      this.Productos = value;
    },

    SelectData2(value) {
      this.Productos = [];
      this.Productos = value;
    },

    FilterChange(index) {
      if (index == 0) {
        this.PushDataGPS(this.data);
      } else {
        this.PushDataTERMINALES(this.data);
      }
    },
    async GetCustomer() {
      this.loading = true;
      await this.$http.get(`/api/customers/GetCustomerFilter`).then((resp) => {
        this.data = resp.data.Clientes;
        this.Empresas = resp.data.Empresas;
        this.PushDataGPS(resp.data.Clientes);
      });
      this.loading = false;
    },
    PushDataGPS(resp) {
      let GPS = resp.filter(
        (element) =>
          !this.Empresas.map((value) => value.rnc).includes(element.rnc)
      );
      this.PushData(GPS);
    },
    PushDataTERMINALES(resp) {
      let Terminales = resp.filter((element) =>
        this.Empresas.map((value) => value.rnc).includes(element.rnc)
      );
      this.PushData(Terminales);
    },
    PushData(resp) {
      resp.forEach((element) => {
        this.clientes.push({
          label: element.Name,
          Value: element.NumContrato
        });
      });
    },
    HandlerOnclick() {
      this.Click = true;
    },
    async GuardarDatosNavision(values) {
      const objet = JSON.stringify([...values]).toString();
      await this.$http.post(
        `/api/customers/UpdateLineContract?ContractLines=${objet}`
      );
      this.Click = false;
      this.value = true;
    }
  }
};
</script>

<style>
#GPS {
  float: right;
}
.v-line {
  border-left: thick solid #000;
  height: 100%;
  left: 50%;
  position: absolute;
}
</style>
